import type { InvoiceConfig } from "@/interfaces/invoiceConfig";

/**
 * Default invoice configuration.
 * Used when no club-specific config exists.
 */
export const defaultInvoiceConfig: InvoiceConfig = {
  title: "FACTURE",
  headerText: "",
  footerText: "Merci pour votre confiance. Nous vous remercions de votre fidélité.",
  signatureLabel: "Signature",
  forClubLabel: "Pour le club",
};
